/* eslint-disable react/destructuring-assignment */
import React from 'react'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete'

const searchOptions = {
  componentRestrictions: {
    country: 'us',
  },
  // types: '(cities)',
}

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = { address: '' }

    this.handleChange.bind(this)
    this.handleSelect.bind(this)
  }

  handleChange(address) {
    this.props.onChange(address)
    this.setState({ address })
  }

  handleSelect(address) {
    console.log(address)
    this.props.onChange(address)
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => console.log('Success', latLng))
      .catch((error) => console.error('Error', error))
  }

  render() {
    return (
      <PlacesAutocomplete
        value={this.state.address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        searchOptions={searchOptions}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div className="autocomplete">
            <input
              {...getInputProps({
                placeholder: 'New York',
                className: 'location-search-input form-control cabinet__input',
              })}
              value={this.props.value}
            />
            {(suggestions.length > 0 || loading) && (
              <div className="autocomplete-dropdown-container">
                {loading && (
                  <div className="autocomplete-loading">Loading...</div>
                )}
                {suggestions.map((suggestion) => {
                  const className = suggestion.active
                    ? 'suggestion-item--active'
                    : 'suggestion-item'
                  // inline style for demonstration purpose
                  const style = suggestion.active
                    ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                    : { backgroundColor: '#ffffff', cursor: 'pointer' }
                  return (
                    <div
                      key={suggestion.id}
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        )}
      </PlacesAutocomplete>
    )
  }
}

export default LocationSearchInput
